<template>
  <section class="hero is-fullheight-with-navbar is-fullheight-with-spaced-navbar jumbotron">
    <div class="hero-body" id="contact-hero-body">
      <div class="container">
        <div class="columns is-vcentered is-variable is-8">
          <div class="column is-one-third-widescreen is-two-fifths-desktop map-column is-hidden-mobile">
            <svg version="1.1"
                id="svg2" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 228.1 338.7"
                style="enable-background:new 0 0 228.1 338.7;" xml:space="preserve">
              <defs>
                  <inkscape:perspective  id="perspective64" inkscape:persp3d-origin="479.5 : 197.66667 : 1" inkscape:vp_x="0 : 296.5 : 1" inkscape:vp_y="0 : 1000 : 0" inkscape:vp_z="959 : 296.5 : 1" sodipodi:type="inkscape:persp3d">
                  </inkscape:perspective>
              </defs>
              <sodipodi:namedview  bordercolor="#666666" borderopacity="1.0" gridtolerance="10.0" guidetolerance="10.0" id="base" inkscape:current-layer="svg2" inkscape:cx="338.54263" inkscape:cy="441.001" inkscape:guide-bbox="true" inkscape:pageopacity="0.0" inkscape:pageshadow="2" inkscape:window-height="716" inkscape:window-maximized="1" inkscape:window-width="1366" inkscape:window-x="-8" inkscape:window-y="-8" inkscape:zoom="1.38" objecttolerance="10.0" pagecolor="#ffffff" showgrid="false" showguides="true">
                </sodipodi:namedview>
              <path id="NH" sodipodi:nodetypes="ccccccccccccccccccccccccccccccccc" class="st0" d="M181.9,142.4l0.9-1.1l1.1-3.3l-2.5-0.9
                l-0.5-3.1l-3.9-1.1l-0.3-2.7l-7.3-23.4l-4.6-14.5h-0.9l-0.6,1.6l-0.6-0.5l-1-1l-1.5,1.9v5l0.3,5.7l1.9,2.7v4l-3.7,5.1L156,118v1.1
                l1.1,1.8v8.6l-0.8,9.2l-0.2,4.8l1,1.3l-0.2,4.5l-0.5,1.8l1,0.7l16.8-4.4l2.2-0.6l1.8-2.8L181.9,142.4z"/>
              <path id="VT" sodipodi:nodetypes="ccccccccccccccccccccccccccccc" class="st0" d="M145.6,154.1l0.3-5.3L143,138l-0.6-0.3l-2.9-1.3
                l0.8-2.9l-0.8-2.1l-2.7-4.6l1-3.9l-0.8-5.2l-2.4-6.5l-0.8-4.9l26.4-6.7l0.3,5.5l1.9,2.7v4l-3.7,5.1L156,118v1.1l1.3,1.5l-0.3,8.1
                l-0.6,9.3l-0.2,5.6l1,1.3l-0.2,4.6l-0.5,1.7l1,0.7l-7.4,1.5L145.6,154.1z"/>
              <path id="ME" sodipodi:nodetypes="ccccccccsccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccsccccc" class="st0" d="
                M223.9,78.8l1.9,2.1l2.3,3.7v1.9l-2.1,4.7l-1.9,0.6l-3.4,3.1l-4.8,5.5c0,0-0.6,0-1.3,0c-0.6,0-1-2.1-1-2.1l-1.8,0.2l-1,1.5l-2.4,1.5
                l-1,1.5l1.6,1.5l-0.5,0.6l-0.5,2.7l-1.9-0.2V106l-0.3-1.3l-1.5,0.3l-1.8-3.2l-2.1,1.3l1.3,1.5l0.3,1.1l-0.8,1.3l0.3,3.1l0.2,1.6
                l-1.6,2.6l-2.9,0.5l-0.3,2.9l-5.3,3.1l-1.3,0.5l-1.6-1.5l-3.1,3.6l1,3.2l-1.5,1.3l-0.2,4.4l-1.1,6.3l-2.5-1.2l-0.5-3.1l-3.9-1.1
                l-0.3-2.7l-7.3-23.4l-4.7-14.6l1.4-0.1l1.5,0.4V90l1.3-4.5l2.6-4.7l1.5-4l-1.9-2.4v-6l0.8-1l0.8-2.7l-0.2-1.5l-0.2-4.8l1.8-4.8
                l2.9-8.9l2.1-4.2h1.3l1.3,0.2v1.1l1.3,2.3l2.7,0.6l0.8-0.8v-1l4-2.9l1.8-1.8l1.5,0.2l6,2.4l1.9,1l9.1,29.9h6l0.8,1.9l0.2,4.8
                l2.9,2.3h0.8l0.2-0.5l-0.5-1.1L223.9,78.8z M203,109l1.5-1.5l1.4,1.1l0.6,2.4l-1.7,0.9L203,109z M209.7,103.1l1.8,1.9
                c0,0,1.3,0.1,1.3-0.2s0.2-2,0.2-2l0.9-0.8l-0.8-1.8l-2,0.7L209.7,103.1z"/>
              <path id="RI" sodipodi:nodetypes="ccccccccccc" class="st0" d="M175.1,178.9l-3.7-15l6.3-1.8l2.2,1.9l3.3,4.3l2.7,4.4l-3,1.6
                l-1.3-0.2l-1.1,1.8l-2.4,1.9L175.1,178.9z"/>
              <path id="NY" class="st0" d="M131.4,188.7l-1.1-1l-2.6-0.2l-2.3-1.9l-1.6-6.1l-3.5,0.1l-2.4-2.7l-19.4,4.4l-43,8.7l-7.5,1.2
                l-0.7-6.5l1.4-1.1l1.3-1.1l1-1.6l1.8-1.1l1.9-1.8l0.5-1.6l2.1-2.7l1.1-1l-0.2-1l-1.3-3.1l-1.8-0.2l-1.9-6.1l2.9-1.8l4.4-1.5l4-1.3
                l3.2-0.5L74,157l1.9,1.3l1.6,0.2l2.1-1.3l2.6-1.1l5.2-0.5l2.1-1.8l1.8-3.2l1.6-1.9H95l1.9-1.1l0.2-2.3l-1.5-2.1l-0.3-1.5l1.1-2.1
                v-1.5h-1.8l-1.8-0.8l-0.8-1.1l-0.2-2.6l5.8-5.5l0.6-0.8l1.5-2.9l2.9-4.5l2.7-3.7l2.1-2.4l2.4-1.8l3.1-1.2l5.5-1.3l3.2,0.2l4.5-1.5
                l7.6-2.1l0.5,5l2.4,6.5l0.8,5.2l-1,3.9l2.6,4.5l0.8,2.1l-0.8,2.9l2.9,1.3l0.6,0.3l3.1,11l-0.5,5.1l-0.5,10.8l0.8,5.5l0.8,3.6
                l1.5,7.3v8.1l-1.1,2.3l1.8,2l0.8,1.7l-1.9,1.8l0.3,1.3l1.3-0.3l1.5-1.3l2.3-2.6l1.1-0.6l1.6,0.6l2.3,0.2l7.9-3.9l2.9-2.7l1.3-1.5
                l4.2,1.6l-3.4,3.6L167,194l-7.1,5.3l-2.6,1l-5.8,1.9l-4,1.1l-1.2-0.5l-0.2-3.7l0.5-2.7l-0.2-2.1l-2.8-1.7l-4.5-1l-3.9-1.1
                L131.4,188.7z"/>
              <path id="PA" sodipodi:nodetypes="cccccccccccccccccccccccccccccccccccccccccccc" class="st0" d="M126.2,224.7l1.3-0.3l2.3-1.3
                l1.2-2.5l1.6-2.3l3.2-3.1v-0.8l-2.4-1.6l-3.6-2.4l-1-2.6l-2.7-0.3l-0.2-1.1l-0.8-2.7l2.3-1.1l0.2-2.4l-1.3-1.3l0.2-1.6l1.9-3.1v-3.1
                l2.7-2.6l-0.9-0.7l-2.5-0.2l-2.3-1.9l-1.5-6.1l-3.5,0.1l-2.5-2.7l-18.1,4.2l-43,8.7l-8.9,1.5l-0.6-6.5l-5.4,5.1l-1.3,0.5l-4.2,3
                l2.9,19.1l2.5,9.7l3.6,19.3l3.3-0.6l11.9-1.5l37.9-7.7l14.9-2.8l8.3-1.6l0.3-0.2l2.1-1.6L126.2,224.7z"/>
              <path id="NJ" sodipodi:nodetypes="ccccccccccccccccccccccccccccccccccccccccccccccccccc" class="st0" d="M130.7,188.5l-2.3,2.7v3.1
                l-1.9,3.1l-0.2,1.6l1.3,1.3l-0.2,2.4l-2.3,1.1l0.8,2.7l0.2,1.1l2.7,0.3l1,2.6l3.6,2.4l2.4,1.6v0.8l-3,2.7l-1.6,2.3l-1.5,2.7
                l-2.3,1.3l-0.5,1.6l-0.2,1.2l-0.6,2.6l1.1,2.2l3.2,2.9l4.8,2.3l4,0.6l0.2,1.5l-0.8,1l0.3,2.7h0.8l2.1-2.4l0.8-4.8l2.7-4l3.1-6.5
                l1.1-5.5l-0.6-1.1l-0.2-9.4l-1.6-3.4l-1.1,0.8l-2.7,0.3l-0.5-0.5l1.1-1l2.1-1.9l0.1-1.1l-0.4-3.4l0.6-2.7l-0.1-2l-2.8-1.8l-5.1-1.2
                l-4.1-1.4L130.7,188.5z"/>
              <path id="DE" sodipodi:nodetypes="cccccccccccccccccccc" class="st0" d="M126.7,228.3l0.4-2.1l0.4-1.7l-1.6,0.4l-1.6,0.5l-2.2,1.8
                l1.7,5l2.3,5.7l2.1,9.7l1.6,6.3l5-0.2l6.1-1.2l-2.3-7.4l-1,0.5l-3.6-2.4l-1.8-4.7l-1.9-3.6l-3.1-2.9l-0.9-2.1L126.7,228.3z"/>
              <path id="MD" sodipodi:nodetypes="ccccccccccccccccccccccccccccccccccccccccccccccccccsccccccccccccccccccccccccccccsccc" class="st0" d="
                M140.9,252.4l-6,1.2l-5.1,0.1l-1.8-6.9l-1.9-9.2l-2.6-6.2l-1.3-4.4l-7.5,1.6l-14.9,2.8L62.3,239l1.1,5l1,5.7l0.3-0.3l2.1-2.4
                l2.3-2.6l2.4-0.6l1.5-1.5l1.8-2.6l1.3,0.6L79,240l2.6-2.1l2-1.5l1.8-0.5L87,237l2.9,1.5l1.9,1.8l1.2,1.5l4.1,1.7v2.9l5.5,1.3
                l1.1,0.5l1.4-2l2.9,2l-1.3,2.5l-0.8,4l-1.8,2.6v2.1l0.6,1.8l5.1,1.4l4.3-0.1l3.1,1l2.1,0.3l1-2.1l-1.5-2.1v-1.8l-2.4-2.1l-2.1-5.5
                l1.3-5.3l-0.2-2.1l-1.3-1.3c0,0,1.5-1.6,1.5-2.3c0-0.6,0.5-2.1,0.5-2.1l1.9-1.3l1.9-1.6l0.5,1l-1.5,1.6l-1.3,3.7l0.3,1.1l1.8,0.3
                l0.5,5.5l-2.1,1l0.3,3.6l0.5-0.2l1.1-1.9l1.6,1.8L120,253l-0.3,3.4l2.6,3.4l3.9,0.5l1.6-0.8l3.2,4.2l1.4,0.5l6.7-2.8l2-4
                L140.9,252.4z M124.9,261.4l1.1,2.5l0.2,1.8l1.1,1.9c0,0,0.9-0.9,0.9-1.2c0-0.3-0.7-3.1-0.7-3.1l-0.7-2.3L124.9,261.4z"/>
              <path id="VA" sodipodi:nodetypes="ccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc" class="st0" d="
                M132.7,266.1l-0.1-1.9l6.5-2.5l-0.8,3.2l-2.9,3.8l-0.4,4.6l0.5,3.4l-1.8,5l-2.2,1.9L130,279l0.4-5.4l1.6-4.2L132.7,266.1z
                M136,294.4L77.8,307l-37.4,5.3l-6.7-0.4l-2.6,1.9l-7.3,0.2l-8.4,1l-10.9,1.6L15,311v-2.1l1.5-2.1l10.6-11.5l3.9,4.5l3.8,1l2.5-1.1
                l2.2-1.3l2.5,1.3l3.9-1.4l1.9-4.6l2.6,0.5l2.9-2.1l1.8,0.5l2.8-3.7l0.3-2.1l-1-1.3l1-1.9l5.3-12.3l0.6-5.7l1.2-0.5l2.2,2.4l3.9-0.3
                l1.9-7.6l2.8-0.6l1-2.7L80,254l2.8-5.7l0.1-5.1l9.8,3.8c0.7,0.3,0.8-5,0.8-5l3.7,1.6l0.1,2.9l5.8,1.3l2.1,1.2l1.7,2.1l-0.7,3.6
                l-1.9,2.6l0.1,2.1l0.6,1.9l5,1.3h4.5l3.1,1l1.9,0.3l0.7,3.1l3.2,0.4l0.9,1.2l-0.4,4.7l1.4,1.1l-0.5,1.9l1.2,0.8l-0.2,1.4l-2.7-0.1
                l0.1,1.6l2.3,1.5l0.1,1.4l1.8,1.8l0.5,2.5l-2.6,1.4l1.6,1.5l5.8-1.7L136,294.4z"/>
              <path id="WV" sodipodi:nodetypes="ccccccccccccccccccccccccccccccccccccccccscccccccccccccccccccccccccccccccccccccccccc" class="st0" d="
                M62.3,239l1.1,4.9l1.1,6l2.1-2.6l2.3-3.1l2.5-0.6l1.5-1.5l1.8-2.6l1.4,0.6L79,240l2.6-2.1l2-1.5l1.8-0.5l1.3,1l3.6,1.8l1.9,1.8
                l1.4,1.3l-0.8,5.6l-5.8-2.5l-4.2-1.6l-0.1,5.2L80,254l-2.5,2.4l-1.2,2.7l-2.6,0.5l-0.9,3.6l-1,3.9l-4,0.3l-2.3-2.4l-1.1,0.6
                l-0.6,5.5l-1.4,3.5l-5,11l0.9,1.2l-0.2,1.9l-2.8,3.9l-1.8-0.5l-3,2.2l-2.5-0.6l-2,4.6c0,0-3.3,1.4-3.9,1.4c-0.2,0-2.5-1.2-2.5-1.2
                l-2.3,1.4l-2.4,1l-3.7-0.9l-1.1-1.2l-2.2-3l-3.1-2l-1.7-3.6l-4.3-3.5l-0.6-2.3l-2.6-1.5l-0.8-1.6l-0.2-5.3l2.2-0.1l1.9-0.8l0.2-2.7
                l1.6-1.5l0.2-5l1-3.9l1.3-0.6l1.3,1.1l0.5,1.8l1.8-1l0.5-1.6l-1.1-1.8v-2.4l1-1.3l2.3-3.4l1.3-1.5l2.1,0.5l2.3-1.6l3.1-3.4l2.3-3.9
                l0.3-5.7l0.5-5v-4.7l-1.1-3.1l1-1.5l1.3-1.3l3.5,19.8l4.6-0.8L62.3,239z"/>
              <path id="OH_1_" sodipodi:nodetypes="cccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc" class="st0" d="M0,273.4
                l2.9,0.3l1.7-2.1l2.3-1.3l2.1-0.7l0.6,2.7l1.8,1l3.5,2.3l2.2-0.1l1.3-0.5l0.2-2.8l1.6-1.5l0.1-4.8l1-4.1l1.3-0.6l1.3,1.1l0.5,1.7
                l1.7-1l0.4-1.5l-1.1-1.9l0.1-2.3l0.7-1.1l2.2-3.3l1.1-1.5l2.1,0.5l2.3-1.6L37,247l2.8-4.1l0.3-5.1l0.5-5l-0.2-5.3l-1-2.9l0.4-1.2
                l1.8-1.8l-2.3-9l-2.9-19.4l-6.1,4.1l-3.9,2.3l-3.4,3.7l-4,3.9l-3.2,0.8l-2.9,0.5l-5.5,2.6l-2.1,0.2l-3.4-3.1L0,208.4V273.4z"/>
              <path id="CT" sodipodi:nodetypes="cccccccccccccccc" class="st0" d="M175.1,178.9l-3.7-14.9l-4.7,0.9l-21.2,4.7l1,3.2l1.5,7.3l0.2,9
                l-1.2,2.2l1.9,1.9l4.3-3.9l3.6-3.2l1.9-2.1l0.8,0.6l2.7-1.5l5.2-1.1L175.1,178.9z"/>
              <path id="NC" sodipodi:nodetypes="cccccccccccccccccccccccccccccccccccccccccccccccccccccccccccscccccccccccccccccccccccccccccccc" class="st0" d="
                M8.1,338.7l3.6-3.1l4.4-2.1l0.6-3.1l3.9-3.9l0.6-0.2c0,0,0,1.1,0.8,1.1s1.9,0.3,1.9,0.3l2.3-3.6l2.1-0.6l2.3,0.3l1.6-3.6l2.9-2.6
                l0.5-2.1l0.2-3.6h4.3l7.2-0.9l15.8-2.3l15.1-2.1l21.6-4.7l20-4.3l11.2-2.4l5-1.2l2.1,4.9l3.6,6.5l2.4,2.4l0.6,2.3l-2.4,0.2l0.8,0.6
                l-0.3,4.2l-2.6,1.3l-0.6,2.1l-1.3,2.9l-3.7,1.6l-2.4-0.3l-1.5-0.2l-1.6-1.3l0.3,1.3v1h1.9l0.8,1.3l-1.9,6.3h4.2l0.6,1.6l2.3-2.3
                l1.3-0.5l-1.9,3.6l-3.1,4.8h-1.3l-1.1-0.5l-2.1,0.5L8.1,338.7z M140.3,327.5l2.6-2.5l3.2-2.6l1.5-0.6l0.2-2l-0.6-6.1l-1.5-2.3
                l-0.6-1.9l0.7-0.2l2.7,5.5l0.4,4.4l-0.2,3.4l-3.4,1.5l-2.8,2.4l-1.1,1.2L140.3,327.5z"/>
              <path id="DC" sodipodi:nodetypes="cccccc" class="st0" d="M106.9,250.8L105,249l-1.2-0.7l1.4-2l2.9,1.9L106.9,250.8z"/>
              <path id="MA" sodipodi:nodetypes="ccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc" class="st0" d="M200.7,173.3
                l2.2-0.7l0.5-1.7l1,0.1l1,2.3l-1.3,0.5l-3.9,0.1L200.7,173.3z M191.3,174.1l2.3-2.6h1.6l1.8,1.5l-2.4,1l-2.2,1L191.3,174.1z
                M156.5,152.1l17.6-4.6l2.3-0.6l1.9-2.8l3.7-1.7l2.9,4.4l-2.4,5.2l-0.3,1.5l1.9,2.6l1.1-0.8h1.8l2.3,2.6l3.9,6l3.6,0.5l2.3-1
                l1.8-1.8l-0.8-2.7l-2.1-1.6l-1.5,0.8l-1-1.3l0.5-0.5l2.1-0.2l1.8,0.8l1.9,2.4l1,2.9l0.3,2.4l-4.2,1.5L195,168l-3.9,4.5l-1.9,1.5v-1
                l2.4-1.5l0.5-1.8l-0.8-3.1l-2.9,1.5l-0.8,1.5l0.5,2.3l-2.1,1l-2.7-4.5l-3.4-4.4l-2.1-1.8l-6.5,1.9l-5.1,1.1l-20.7,4.6l-0.7-4.8
                l0.6-10.6l4.3-0.9L156.5,152.1z"/>
              <path id="TN_1_" sodipodi:nodetypes="ccccccccccccccccccccccccccccccsccccccccccccc" class="st0" d="M8.1,338.7l3.6-3.1l4.4-2
                l0.5-3.1l4.1-4l0.6-0.1c0,0,0,1.1,0.8,1.1s1.9,0.4,1.9,0.4l2.3-3.6l2.1-0.6l2.3,0.3l1.6-3.5l3-2.6l0.4-1.9l0.3-3.7l-2.1-0.2l-2.6,2
                h-7l-18.4,2.4L0,317.7v21H8.1z"/>
              <path id="KY_1_" sodipodi:nodetypes="ccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc" class="st0" d="
                M0,273.4h0.3l2.6,0.2l1.7-2.1l2.6-1.4l1.9-0.7l0.6,2.8l2,1.1l2.6,2.1l0.1,5.7l0.8,1.6l2.6,1.6l0.8,2.3l4.2,3.4l1.8,3.6l2.5,1.7
                l-2.3,2.4l-3.6,4l-4.9,5.5l-1.2,1.7L15,311l-4.4,2.2l-5.7,3.4L0,317.7V273.4z"/>
              <circle @mouseover="filter(0)" @mouseleave="filter(null)" id="new-york" cx="153.5" cy="195.9" r="4"/>
              <circle @mouseover="filter(1)" @mouseleave="filter(null)" id="new-england" cx="173.2" cy="155.4" r="4"/>
              <circle @mouseover="filter(2)" @mouseleave="filter(null)" id="chesapeake" cx="109.2" cy="239.9" r="4"/>
              <circle @mouseover="filter(3)" @mouseleave="filter(null)" id="mid-atlantic" cx="133.3" cy="219.4" r="4"/>
            </svg>
          </div>
          <div v-scroll-reveal="{ delay: 30 }" class="column is-two-thirds-widescreen is-three-fifths-desktop load-hidden">
            <div class="contact-us-title is-flex">
              <span :key="0" class="title">Contact Us</span>
              <div class="manager">
                <span class="subtitle">President</span>
                <div class="manager-title">
                  <div>Mark Wachtel</div>
                  <a href="mailto:mwachtel@sjassoc.com" target="_blank" class="email">mwachtel@sjassoc.com</a>
                </div>
              </div>
            </div>
            <hr/>
            <div class="columns is-multiline is-2 is-variable">
              <div v-for="(location, index) in locations" :key="index" class="column is-half-widescreen is-full-desktop is-full-tablet is-full-mobile">
                <div class="location" @mouseover="filter(index)" @mouseleave="filter(null)" :class="{ 'active': activeLocation == index }">
                  <div class="location-title">
                    <h1 class="title">{{ $prismic.richTextAsPlain(location.location_name) }}</h1>
                    <div class="subtitle established">Est. {{ $prismic.richTextAsPlain(location.year_established) }}</div>
                  </div>
                  <div class="manager">
                    <div class="manager-title">
                    <div class="subtitle">{{ $prismic.richTextAsPlain(location.manager_title) }}</div>
                      <div>{{ $prismic.richTextAsPlain(location.manager_name) }}</div>
                      <div>{{ $prismic.richTextAsPlain(location.manager_email) }}</div>
                    </div>
                    <div class="manager-contact">
                      <a :href="`mailto:${$prismic.richTextAsPlain(location.manager_email)}`" target="_blank" class="button is-uppercase">Contact</a>
                    </div>
                  </div>
                  <div class="address">
                    {{ $prismic.richTextAsPlain(location.address_line_1) }}
                    <br/>
                    {{ $prismic.richTextAsPlain(location.address_line_2) }}
                  </div>
                  <div class="phone">
                    <div class="subtitle">Phone</div>
                    <div>{{ $prismic.richTextAsPlain(location.phone) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactMap',
  data () {
    return {
      locations: {},
      activeLocation: null,
    }
  },
  methods: {
    getLocations() {
      this.$prismic.client.getSingle('locations')
        .then((locationsContent) => {
          this.locations = locationsContent.data.locations;
        })
    },
    filter (idx) {
      document.querySelectorAll('.location').forEach(function(location, index) {
        if (index == idx) {
          location.classList.add('active');
        } else {
          location.classList.remove('active');
        }
      });

      document.querySelectorAll('circle').forEach(function(marker, index) {
        if (index == idx) {
          marker.classList.add('active');
        } else {
          marker.classList.remove('active');
        }
      });

      // document.querySelectorAll('.location-title .title').forEach(function(location, index) {
      //   if (index == idx) {
      //     location.classList.add('title-white');
      //   } else {
      //     location.classList.remove('title-white');
      //   }
      // });

      // document.querySelectorAll('.button').forEach(function(button, index) {
      //   if (index == idx) {
      //     button.classList.add('active');
      //   } else {
      //     button.classList.remove('active');
      //   }
      // });
    }
  },
  created () {
    this.getLocations();
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";

.st0{fill:$lightBlue;opacity:1;stroke:#FFFFFF;stroke-width:0.75;}

circle {
  cursor: pointer;
  transition: .3s fill;
  fill: $medBlue;
  &:hover {
    fill: $navy;
  }
  &.active {
    fill: $navy;
  }
}

.container {
  padding-top: 0;
  padding-bottom: 0;
  @media screen and (max-width: $widescreen) {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}

.hero-body {
  padding-top: 0;
  padding-bottom: 0;
  overflow-y: hidden;
  @media screen and (max-width: $widescreen) {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
}

#contact-hero-body {
  align-items: flex-end;
  @media screen and (max-width: $widescreen) {
    align-items: center;
  }
}

.president {
  background: $teal;
  opacity: 0.8;
  color: $navy;
  transition: .3s all;
  padding: 10px;
  .title {
    color: $navy;
    transition: 0.3s all;
  }
  .subtitle {
    color: $navy;
    transition: 0.3s all;
  }
  .title {
    font-size: 32px;
  }
  .subtitle {
    margin-bottom: 0;
  }

  .manager, .address {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    .manager-contact {
      .button {
        transition: .3s all;
        color: $navy;
        border: 2px solid $navy;
      }
    }
  }
}

.contact-us-title {
  justify-content: space-between;
  align-items: center;
  color: $navy;
  .email {
    color: $navy;
    transition: color 0.2s ease-in-out;
    &:hover {
      color: $teal;
    }
  }
}

.location {
  background: $lightBlue;
  opacity: 0.8;
  color: $navy;
  transition: .3s all;
  padding: 10px;
  .title {
    color: $navy;
    transition: 0.3s all;
  }
  .subtitle {
    color: $navy;
    transition: 0.3s all;
  }
  &.column {
    // width: calc(50% - 10px);
    // margin: 5px;
    // @media screen and (max-width: $tablet) {
    //   width: 100%;
    // }
  }
  .title {
    font-size: 32px;
  }
  .subtitle {
    margin-bottom: 0;
  }

  .manager, .address {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    .manager-contact {
      .button {
        transition: .3s all;
        color: $navy;
        border: 2px solid $navy;
      }
    }
  }

  .location-title {
    align-items: center;
  }

  .location-title, .phone, .fax {
    display: flex;
    justify-content: space-between;
  }

  &.active {
    opacity: 1;
    background: $navy;
    color: $white;
    .title {
      color: $white;
    }
    .subtitle {
      color: $white;
    }
    .manager-contact {
      .button {
        color: $white;
        border: 2px solid $white;
        &:hover {
          color: $navy;
          background: $white;
        }
      }
    }
  }
}

.hero.jumbotron {
  // background-image: url('~@/assets/img/us-map-2_cropped-02_new.svg');
  background-position: left;
  background-size: 50%;
  background-repeat: no-repeat;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    background: $white;
    width: 100%;
    height: 100%;
  }
}

.map-column {
  text-align: right;
  width: 100% !important;
  margin-left: -66.6%;
  padding: 0;
  @media screen and (max-width: $desktop) {
    margin-left: -40%;
  }
  svg {
    width: 100%;
    max-width: 50vw;
    max-height: 100%;
  }
}

// .map-image {
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   overflow: hidden;
//   @media screen and (max-width: $desktop) {

//   }
//   svg {
//     max-width: 60vw;
//     max-height: 100%;
//     position: absolute;
//     left: -100px;
//     z-index: 100;
//     bottom: 0;
//     @media screen and (max-width: $desktop) {
//       position: relative;
//       z-index: 0;
//       max-width: 80vw;
//     }
//     @media screen and (max-width: $tablet) {
//       max-width: 100vw;
//     }
//   }
// }

// .hero-body {
//   z-index: 1000;
// }

// .marker {
//   cursor: pointer;
//   position: absolute;
//   z-index: 1;
//   display: inline-block;
//   width: 36px;
//   height: 36px;
//   color: $navy;
//   line-height: 36px;
//   text-align: center;
//   text-decoration: none;
//   border-radius: 50%;
//   background-color: $lightBlue;
//   transition: all 300ms;

//   &.active {
//     background-color: $navy;
//     color: $white;
//   }
// }

// #marker1 {
//     top: 42%;
//     left: 63%;
// }
// #marker2 {
//     top: 55%;
//     left: 59%;
// }
// #marker3 {
//     top: 57%;
//     left: 47%;
// }
// #marker4 {
//     top: 68%;
//     left: 39%;
// }

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
